var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import styled from "styled-components";
import { Nav, NavItem } from "react-bootstrap";
import { label3 } from "@irati/ui/src/Labels/css/labels";
import { greys } from "@irati/ui/src/global/colors";
export var StyledNav = styled(Nav)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
export var StyledNavItem = styled(function (_a) {
    var activeColor = _a.activeColor, fullWidth = _a.fullWidth, rest = __rest(_a, ["activeColor", "fullWidth"]);
    return React.createElement(NavItem, __assign({}, rest));
})
    .attrs({
    // @ts-ignore
    bold: "true",
    uppercase: "true"
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  &&& {\n    ", "\n    &+& {\n      margin-left: 0;\n    }\n    &.active {\n      a {\n        &, &:hover, &:focus {\n          ", "\n        }\n        &:focus {\n          background-color: transparent;\n        }\n        &:hover {\n          background-color: ", ";\n        }\n      }\n    }\n    a {\n      &, &:hover, &:focus {\n        ", "\n        background-color: transparent;\n        color: ", ";\n        border-radius: 0;\n        padding: 15px 10px 10px;\n        text-align: center;\n      }\n\n      &:hover, &:focus {\n        background-color: ", ";\n        border-bottom: 5px solid ", ";\n      }\n    }\n  }\n"], ["\n  &&& {\n    ",
    "\n    &+& {\n      margin-left: 0;\n    }\n    &.active {\n      a {\n        &, &:hover, &:focus {\n          ",
    "\n        }\n        &:focus {\n          background-color: transparent;\n        }\n        &:hover {\n          background-color: ", ";\n        }\n      }\n    }\n    a {\n      &, &:hover, &:focus {\n        ", "\n        background-color: transparent;\n        color: ", ";\n        border-radius: 0;\n        padding: 15px 10px 10px;\n        text-align: center;\n      }\n\n      &:hover, &:focus {\n        background-color: ", ";\n        border-bottom: 5px solid ", ";\n      }\n    }\n  }\n"])), function (_a) {
    var fullWidth = _a.fullWidth;
    return fullWidth && "\n      float: none;\n      display: table-cell;\n      width: 1%;\n    ";
}, function (_a) {
    var activeColor = _a.activeColor;
    return activeColor && "\n            border-bottom: 5px solid " + activeColor + ";\n          ";
}, greys.light, label3, greys.black, greys.light, greys.light);
var templateObject_1, templateObject_2;
